<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-btn
      color="red darken-3"
      text
      x-large
      dark
      @click="$router.push({ name: 'Partners' })"
    >
      <v-icon
        left
        dark
      >
        mdi-arrow-left-bold
      </v-icon>
      Back
    </v-btn>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-database
      </v-icon> Partner APIs
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="showAddPartnerApiForm = true"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Add New
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="partnerApiList"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.method }}</td>
            <td>{{ item.uri }}</td>
            <td>{{ item.created_at | convertToLocal }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#C62828"
                @click="deleteApi()"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <add-new-partner-api
      v-if="showAddPartnerApiForm"
      @partner-api-success="getPartnerApiList"
      @closed="showAddPartnerApiForm = false"
    />
  </v-container>
</template>

<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  import AddNewPartnerAPI from './AddNewPartnerAPI.vue';

  export default {
    name: 'PartnerAPIsList',
    components: {
      'centre-spinner': spinner,
      'add-new-partner-api': AddNewPartnerAPI,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Method', value: 'method' },
          { text: 'Uri', value: 'uri' },
          { text: 'Added On', value: 'created_at' },
          { text: 'Delete', value: 'delete' },
        ],
        showAddPartnerApiForm: false,
      };
    },
    computed: {
      partnerApiList () {
        const list = this.$store.getters['partners/getPartnerApiList'];
        const sortedList = list.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        return sortedList;
      },
    },
    async mounted () {
      await this.getPartnerApiList();
    },
    methods: {
      async getPartnerApiList () {
        this.loading = true;
        const partnerId = this.$route.params.id;
        await this.$store.dispatch('partners/fetchPartnerApiList', {
          partnerId: partnerId,
        });
        this.loading = false;
      },
      deleteApi () {
        this.$store.dispatch('alert/onAlert', {
          message: 'You are not authorized to perform this action, please contact your administrator.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
</style>
